import { DEFAULT_LOCALE } from 'shared/consts'
import store from 'shared/store'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'
import buildClientAPI from 'views/providers/clientAPI'

export const newsletterUnsubscriptionHookName = 'h-UnsubscriptionContent'

const selector = `[data-clientside-hook~="${newsletterUnsubscriptionHookName}"]`

const mountComponent = async container => {
  const {
    publicConfig: { locale = DEFAULT_LOCALE },
  } = store.getPublicRuntimeConfig()

  const { mailingSubscriptionService } = buildClientAPI()

  const i18n = await loadCatalogs(locale)
  const { default: hydrateComponent } = await import(
    /* webpackChunkName: "NewsletterUnsubscriptionWithHydration", webpackPrefetch: true */
    './NewsletterUnsubscriptionWithHydration'
  )

  hydrateComponent({
    i18n,
    container,
    mailingSubscriptionService,
  })
}

export default () => {
  const el = document.querySelector(selector)

  if (el) {
    mountComponent(el)
  }
}
